export enum MediaType {
    PDF,
    IMAGE
}